<div class="container mt-5">
    <div class="card text-center border-danger">
      <div class="card-body">
        <i class="fas fa-times-circle text-danger mb-3" style="font-size: 3rem;"></i>
        <h5 class="card-title">{{ '::PaymentCancel:Title' | abpLocalization }}</h5>
        <p class="card-text">{{ '::PaymentCancel:Message' | abpLocalization }}</p>
        <a href="/" class="btn btn-primary">{{ '::PaymentCancel:ReturnHome' | abpLocalization }}</a>
      </div>
    </div>
  </div>